
import { Component, Vue } from 'vue-property-decorator';


@Component({
    components:{
    }
})
export default class CancelSubmitManualForm extends Vue {

 
    mountedData = false;     

    mounted() {
        this.mountedData = false;
        this.deleteApplication();
        this.mountedData = true;                   
    } 
    
    public deleteApplication() {

        const caseId = this.$route.params?.id
        const data ={
            data:{
                ids:[caseId]
            }
        }

        const url = '/manual-submissions/forms';
        this.$http.delete(url, data)
        .then(response => {
        }, err => {            
        })
    }

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
